import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

import LeMerridian from "../../../assets/images/MeetupImages/unsplash_xEaAoizNFV8.png";
import Session from "../../../assets/images/email.png";

const JuryDashSchedule = () => {

return (
<>
<div className="row m-3">


            <div className="col-md-3">
                <Link to='/superstar/event-date' className='LinkEventSchedule'>
                <div className="card card-bg my-3 card-dashbord">
                    <div className="card-body">
                        <center>
                            <img src={Session} className="img-fluid ADImgSchedule" alt="" />
                            <div className="centeredImgC fw-bold  mt-2">23</div>
                        </center>
                    </div>
                    <div className="d-flex justify-content-center PendingAdSchedule">
                        <p className="fw-bold text-dark mt-4">January , 2022</p>
                    </div>
                </div>
                </Link>
            </div>

            <div className="col-md-3">
                <Link to='/superstar/event-date' className='LinkEventSchedule'>
                <div className="card card-bg my-3 card-dashbord">
                    <div className="card-body">
                        <center>
                            <img src={Session} className="img-fluid ADImgSchedule" alt="" />
                            <div className="centeredImgC fw-bold  mt-2">23</div>
                        </center>
                    </div>
                    <div className="d-flex justify-content-center ApprovedAdSchedule">
                        <p className="fw-bold mt-4">February , 2022</p>
                    </div>
                </div>
                </Link>
            </div>
            <div className="col-md-3">
                <Link to='/superstar/event-date' className='LinkEventSchedule'>
                <div className="card card-bg my-3 card-dashbord">
                    <div className="card-body">
                        <center>
                            <img src={Session} className="img-fluid ADImgSchedule" alt="" />
                            <div className="centeredImgC fw-bold  mt-2">23</div>
                        </center>
                    </div>
                    <div className="d-flex justify-content-center ApprovedAdSchedule">
                        <p className="fw-bold mt-4">March , 2022</p>
                    </div>
                </div>
                </Link>
            </div>
            <div className="col-md-3">
                <Link to='/superstar/event-date' className='LinkEventSchedule'>
                <div className="card card-bg my-3 card-dashbord">
                    <div className="card-body">
                        <center>
                            <img src={Session} className="img-fluid ADImgSchedule" alt="" />
                            <div className="centeredImgC fw-bold  mt-2">23</div>
                        </center>
                    </div>
                    <div className="d-flex justify-content-center ApprovedAdSchedule">
                        <p className="fw-bold mt-4">April , 2022</p>
                    </div>
                </div>
                </Link>
            </div>

            <div className="col-md-3">
                <Link to='/superstar/event-date' className='LinkEventSchedule'>
                <div className="card card-bg my-3 card-dashbord">
                    <div className="card-body">
                        <center>
                            <img src={Session} className="img-fluid ADImgSchedule" alt="" />
                            <div className="centeredImgC fw-bold  mt-2">23</div>
                        </center>
                    </div>
                    <div className="d-flex justify-content-center PendingAdSchedule">
                        <p className="fw-bold mt-4">May , 2022</p>
                    </div>
                </div>
                </Link>
            </div>

    </div>
</>
);
};

export default JuryDashSchedule;